import React from 'react';
import { Title, BodyTeam } from './styles';

/** import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';

import Typography from '@material-ui/core/Typography'; */

import CentralListOfCategories01 from '../../../../components/CentralListOfCategories01';
import CentralListOfCategories02 from '../../../../components/CentralListOfCategories02';
import CardModel1 from './CardModel1';

import Avatar1 from '../../../Team/img/avataaars 1.png';
import Avatar2 from '../../../Team/img/avataaars (2) 1.png';
import Avatar3 from '../../../Team/img/avataaars (3) 1.png';
import Avatar4 from '../../../Team/img/avataaars (1) 1.png';
import Avatar5 from '../../../Team/img/avataaars (4) 1.png';
import Avatar6 from '../../../Team/img/avataaars (6) 1.png';
import Avatar7 from '../../../Team/img/avataaars (5) 1.png';
import Avatar8 from '../../../Team/img/avataaars (7) 1.png';
import Avatar9 from '../../../Team/img/avataaars (11) 1.png';
import Avatar10 from '../../../Team/img/avataaars (9) 1.png';
import Avatar11 from '../../../Team/img/avataaars (10) 1.png';
import Avatar12 from '../../../Team/img/avataaars (8) 1.png';
import Avatar13 from '../../../Team/img/avataaars (12) 1.png';
import Avatar14 from '../../../Team/img/avataaars (14) 1.png';
import Avatar15 from '../../../Team/img/avataaars (13) 1.png';

export default function Team() {
  return (
    <BodyTeam>
      <Title />
      <CentralListOfCategories01 title="Equipe Atual">
        <CentralListOfCategories02 title="Professores">
          <CardModel1
            id="card1"
            title="Antônio de Souza"
            imgSrc={Avatar1}
            route="/template-page-03"
          />
          <CardModel1
            id="card1"
            title="Júlia Andrade"
            imgSrc={Avatar2}
            imgAlt="Microscope"
            route="/template-page-03"
          />
        </CentralListOfCategories02>
        <CentralListOfCategories02 title="Pós-doutorandos">
          <CardModel1
            id="card1"
            title="Andressa Mello"
            imgSrc={Avatar3}
            imgAlt="Microscope"
            route="/template-page-03"
          />
          <CardModel1
            id="card1"
            title="Danilo Gondin"
            imgSrc={Avatar4}
            imgAlt="Microscope"
            route="/template-page-03"
          />
        </CentralListOfCategories02>
        <CentralListOfCategories02 title="Doutorandos">
          <CardModel1
            id="card1"
            title="Larissa Pereira"
            imgSrc={Avatar5}
            imgAlt="Microscope"
            route="/template-page-03"
          />
          <CardModel1
            id="card1"
            title="Bruna Bastos"
            imgSrc={Avatar6}
            imgAlt="Microscope"
            route="/template-page-03"
          />
        </CentralListOfCategories02>
        <CentralListOfCategories02 title="Mestrandos">
          <CardModel1
            id="card1"
            title="Júlio Amorim"
            imgSrc={Avatar7}
            imgAlt="Microscope"
            route="/template-page-03"
          />
          <CardModel1
            id="card1"
            title="Raissa Nakamura"
            imgSrc={Avatar8}
            imgAlt="Microscope"
            route="/template-page-03"
          />
          <CardModel1
            id="card1"
            title="Nelson Nagem"
            imgSrc={Avatar9}
            imgAlt="Microscope"
            route="/template-page-03"
          />
          <CardModel1
            id="card1"
            title="Paula Oliveira"
            imgSrc={Avatar10}
            imgAlt="Microscope"
            route="/template-page-03"
          />
        </CentralListOfCategories02>
        <CentralListOfCategories02 title="Graduandos">
          <CardModel1
            id="card1"
            title="Lucas Nogueira"
            imgSrc={Avatar11}
            imgAlt="Microscope"
            route="/template-page-03"
          />
          <CardModel1
            id="card1"
            title="Nathan Nunes"
            imgSrc={Avatar12}
            imgAlt="Microscope"
            route="/template-page-03"
          />
          <CardModel1
            id="card1"
            title="Luana Lacerda"
            imgSrc={Avatar13}
            imgAlt="Microscope"
            route="/template-page-03"
          />
        </CentralListOfCategories02>
      </CentralListOfCategories01>
      <CentralListOfCategories01 title="Alumni">
        <CentralListOfCategories02 title="2019">
          <CardModel1
            id="card1"
            title="Felipe Pedroso"
            imgSrc={Avatar14}
            imgAlt="Microscope"
            route="/template-page-03"
          />
          <CardModel1
            id="card1"
            title="Alessandra Franco"
            imgSrc={Avatar15}
            imgAlt="Microscope"
            route="/template-page-03"
          />
        </CentralListOfCategories02>
      </CentralListOfCategories01>
    </BodyTeam>
  );
}
